/* Presentation only: do not mutate native prices, variants or customization inputs. */
(() => {
  'use strict';
  const section = document.querySelector('[id^="MainProduct-"]');
  const badge = section?.querySelector('[data-np-purchase-activity]');
  if (!section || !badge || badge.dataset.bound) return;
  badge.dataset.bound = 'true';
  const info = section.querySelector('[id^="ProductInfo-"]');
  if (!info) return;
  let frame = 0;
  const visible = element => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  function place() {
    frame = 0;
    const price = [...info.querySelectorAll('.tee-product-price')].find(visible)
      || [...info.querySelectorAll('.product-page-price')].find(visible);
    if (!price) { badge.hidden = true; return; }
    // Leave the badge outside the price node; price updates remain native.
    if (price.nextElementSibling !== badge) price.after(badge);
    if (badge.hidden) badge.hidden = false;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(place); }
  const observer = new MutationObserver(schedule);
  observer.observe(info, { childList: true, subtree: true });
  document.addEventListener('teeinblue-component-injected', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('pagehide', () => {
    observer.disconnect(); cancelAnimationFrame(frame);
    window.removeEventListener('resize', schedule);
    document.removeEventListener('teeinblue-component-injected', schedule);
  }, { once: true });
  place();
})();
